import React from "react";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../store";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useAuth((state) => state.isAuthenticated);

  const goHome = () => {
    if (isAuthenticated) {
      navigate("/");
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <Result
        status="404"
        title="Oops! Page Not Found"
        subTitle="You might entered a wrong url. Please check the url and try again."
        extra={
          <div className="space-x-2">
            <Button type="primary" onClick={goHome}>
              {isAuthenticated ? "Go Home" : "Go to Login"}
            </Button>
            {!isAuthenticated && (
              <Button onClick={() => navigate("/login")}>Login</Button>
            )}
          </div>
        }
      />
    </div>
  );
};

export default PageNotFound;
